<template>
    <div class="warranty-box-wrapper" v-if="cart.isWarrantySelected">
        <div class="warantyPopupOuter" v-if="cart.popoverShow" id="popoverWarranty">
            <div class="warantyPopupInner">
                <div class="warantyPopupInner__head">
                    <div class="warantyPopupInner__heading">{{ fields.tr_popover_heading_text }}</div>
                    <span class="warantyPopupInner__cross" @click="cart.popoverShow = false;cart.popoverInteracted = 'deny';" :style="`background-image: url(${baseUrl}templates/checkout1.1/app/public/cross.svg)`"></span>
                </div>
                <div class="warantyPopupInner__content">
                    <p class="warantyPopupInner__text">{{ fields.tr_popover_body_text }}</p>
                    <button class="cta__accept cta__accept--warranty" @click="cart.warrantyState = true;cart.popoverInteracted = 'accept';">{{ fields.tr_popover_button_text }}</button>
                </div>
            </div>
            <div class="warantyPopupOuter__arrow"></div>
        </div>
        <div v-if="cart.product !== null" class="warranty-box">
            <div class="warranty-box--inner">
                <div class="warranty-box-title">
                    <div class="warranty-box-title--inner d-flex flex-row justify-content-start align-items-center">
                        <div class="position-relative checkbox">
                            <input id="warrantyCb" v-model="cart.warrantyState" class="mr-2" type="checkbox" @click="cart.warrantyState = !cart.warrantyState">
                            <!--                                    <div class="position-absolute total-arrow">
                                                                    <img alt="" src="/swatch/arrow.svg" width="20px">
                                                                </div>-->
                        </div>
                        <label for="warrantyCb">
                            <b v-if="directCheck" v-html="warrantyTexts?.tr_product_pack_warranty_box_title_clean ? warrantyTexts?.tr_product_pack_warranty_box_title_clean : fields.tr_lifetime_protection_text_clean"></b>
                            <b v-else v-html="warrantyTexts?.tr_product_pack_warranty_box_title ? warrantyTexts?.tr_product_pack_warranty_box_title : fields.tr_lifetime_protection_text"></b>
                        </label>
                    </div>
                </div>
                <p class="p-3"><span class="font-weight-bold" v-html="warrantyTexts?.tr_one_time_offer_text ? `${warrantyTexts?.tr_one_time_offer_text}: ` : `${fields.tr_one_time_offer}: `"></span>
                    <span v-if="directCheck" v-html="warrantyTexts?.tr_product_pack_warranty_box_body_text_clean ? warrantyTexts?.tr_product_pack_warranty_box_body_text_clean : fields.tr_one_time_offer_body_text_clean"></span>
                    <span v-else v-html="warrantyTexts?.tr_product_pack_warranty_box_body_text ? warrantyTexts?.tr_product_pack_warranty_box_body_text : fields.tr_one_time_offer_body_text"></span>
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>
import {useCartStore} from "../state/cart";
const fields = window.msg
const baseUrl = window.baseUrl
const directCheck = window.affiliate.indexOf("direct") !== -1;
const cart = useCartStore()
const warrantyTexts = cart.warrantyTexts;
</script>

<style scoped lang="scss">
/* Warranty checkbox component */
.warranty-box-wrapper {
  margin-top: 15px;

  .warranty-box {
    background: #fff;

    .warranty-box--inner {
      border: 1px solid #e0e0e0;
      border-radius: 5px;
      @media screen and (max-width: 374px) {
        font-size:12px;
      }

      .warranty-box-title {
        background: #F8F9FA;
        padding: 8px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;

        .checkbox {
          margin-left: 4px;

          .warranty-box input {
            height: unset;
          }
        }
      }
    }
  }
}

/* Popover */

.warantyPopupOuter {
  position: relative;
  top: -5px;
  z-index: 120;
  //display: none;
  &--active {
    display: block;
  }
  &__arrow {
    position: absolute;
    top: -9px;
    left: 12px;
    width: 16px;
    height: 16px;
    transform: rotate(45deg);
    background-image: linear-gradient(-45deg, transparent 50%, white 50%);
    background-color: white;
    z-index: 14;
    box-shadow: 2px 2px 3px 0 #00000017;
  }
}

.warantyPopupInner {
  overflow: hidden;
  position: absolute;
  display: inline-block;
  z-index: 14;
  top: 0;
  max-width: 336px;
  width: 100%;
  transform: translateY(-100%);
  box-shadow: 0 0 8px 0 #00000040;
  background-color: #fff;
  border-radius: 10px;

  &__head {
    background-color: #f4f4f4;
    position: relative;
  }

  &__heading {
    font-size: 18px;
    line-height: 20px;
    font-weight: 700;
    font-family: Work Sans, sans-serif;
    color: #4f4f4f;
    text-transform: capitalize;
    text-align: center;
    padding: 16px;
  }

  &__cross {
    position: absolute;
    right: 11px;
    top: 11px;
    width: 10.5px;
    height: 10.5px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
  }

  &__content {
    padding: 16px 16px 17px 16px;
  }

  &__text {
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    font-family: Work Sans, sans-serif;
    color: #4f4f4f;
    margin-bottom: 16px;
  }
}

.cta {
  width: 100%;
  display: grid;
  grid-template-rows: repeat(2, min-content);
  row-gap: 8px;
  justify-items: center;
  &__accept {
    width: 100%;
    font-size: 22px;
    line-height: 24px;
    font-weight: 700;
    font-family: Work Sans, sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 28px 8px;
    border-bottom: 2px solid;
    margin-bottom: -2px;
    border-radius: 10px;
    text-transform: uppercase;
    text-decoration: none;
    &:after {
      content: '';
      opacity: 0;
      transition: opacity 250ms ease-in;
    }
    &:before {
      content: '';
      opacity: 0;
      transition: opacity 250ms ease-in;
    }
    &--warranty {
      width: 100%;
      font-size: 16px;
      line-height: 24px;
      font-weight: 700;
      font-family: Work Sans, sans-serif;
      background-color: #29af5c;
      border: none;
      border-bottom: 2px solid #0f6a28;
      border-radius: 10px;
      color: #fff;
      text-transform: uppercase;
      cursor: pointer;
      padding: 8px 0;
    }
  }
}
</style>